export default "__VITE_PUBLIC_ASSET__5dd2a53f__"